<template lang="pug">
	.easy-creative--settings.flex-col.space-large(:class="{ visible: visible || simpleView, 'simple-view': simpleView }")
		.flex-row.justify.align-center(v-if="!simpleView")
			.font-lg {{$tCaption('Settings')}}
			DxButton(styling-mode="text", icon="close", @click="visible = false")
		DxScrollView.settings-scroll(width="100%", showScrollbar="always")
			EasyCreativeSettingsColorScheme(:info="info")
		.flex-row.space.align-center(v-if="!simpleView")
			DxButton(:text="$tCaption('Save', '@actions')", @click="save", type="default")
			DxButton(:text="$tCaption('Reset', '@actions')", @click="reset")
</template>

<script>
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';
	import DxButton from 'devextreme-vue/button';
	import Popup from 'app-core/Popup.vue';
	import DxScrollView from 'devextreme-vue/scroll-view';
	import DxColorBox from 'devextreme-vue/color-box';
	import EasyCreativeSettingsColorScheme from './EasyCreativeSettingsColorScheme.vue';

	export default {
		translationCategory: 'creative.EasyCreative',
		name: 'easy-creative-settings',
		props: ['info', 'simpleView'],
		components: {
			DxButton, Loader, Popup, DxScrollView, DxColorBox, EasyCreativeSettingsColorScheme
		},
		data() {
			return {
				visible: false
			};
		},
		computed: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeSettings = this;
			this.$onColorChange = _.debounce(this.onColorChange, 100, {
				leading: false,
				trainling: true,
				maxWait: 400
			});
		},
		destroyed() {
			delete this.$onColorChange;
		},
		methods: {
			show() {
				this.visible = false;
				this.$initVars = _.cloneDeep(this.info.branding.JsonConfig);
				this.$nextTick(() => this.visible = true);
			},
			async save() {
				this.$Data.postExternalApi('BriefBranding/CreateUpdateBriefBranding', {
					...this.info.branding,
					JsonConfig: JSON.stringify(this.info.brandingVars)
				});
				this.visible = false;
			},
			reset() {
				this.$set(this.info.branding, 'JsonConfig', {});
			},
			onColorChange(e, color) {
				if (__DEBUG__)
					console.debug('onColorChange', { e, color });
				this.$set(this.info.branding.JsonConfig, color, e.value);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.easy-creative--settings {
		&:not(.simple-view) {
			position: fixed;
			top: 0px;
			right: -100%;
			width: 300px;
			height: 100%;
			box-shadow: 2px 2px 13px 2px rgba(0,0,0,0.1);

			&.visible {
				right: 0px;
			}
		}

		background: var(--branding-bg);
		padding: 20px;
		transition: 0.3s;

		.settings-scroll {
			height: calc(100% - 20px);
		}
	}
</style>
